import _styled from '@emotion/styled/base';
import IconButton from '../Button/IconButton.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledEndAdornment = /*#__PURE__*/_styled(IconButton, {
  shouldForwardProp: isStyledPropsValid,
  target: "eyqaeyg2"
})(_ref => {
  return {
    '&.MuiButtonBase-root': {
      '& .MuiSvgIcon-root': {
        width: '1em',
        height: '1em',
        marginRight: '5px'
      }
    }
  };
}, "");
const StyledIconPlaceholder = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "eyqaeyg1"
})(_ref2 => {
  return {};
}, "");
const StyledContainerTypeCounter = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "eyqaeyg0"
})(_ref3 => {
  let {
    theme,
    multiline
  } = _ref3;
  return {
    fontSize: theme.fontSize.TINY,
    color: theme.customColors.grey[500],
    paddingRight: multiline ? '0px' : '12px',
    paddingLeft: '5px'
  };
}, "");
export { StyledContainerTypeCounter, StyledEndAdornment, StyledIconPlaceholder };